import { gql } from '@apollo/client'

export const Query = gql`
  query DocumentType($companyId: ID!, $filters: DocumentTypeFilters) {
    documentTypes(companyId: $companyId, filters: $filters) {
      nodes {
        id
        name
        subject
        dateDue
        dateIssued
        freeagentResource
        xeroResource
        incrementStart
        incremental
        nextNumber
      }
    }
  }
`
